(() => {
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const header=document.querySelector('.site-header');
  if(header)new ResizeObserver(()=>document.documentElement.style.setProperty('--header-height',header.getBoundingClientRect().height+'px')).observe(header);
  const carousel=document.querySelector('.promo-carousel'),slides=[...document.querySelectorAll('.promo-slide')];
  let active=0,timer,transitioning=false;
  async function rotate(){
    if(document.hidden||carousel.contains(document.activeElement)||transitioning)return;
    transitioning=true;
    const previous=slides[active];
    const outgoing=previous.animate([{transform:'translateX(0)',opacity:1,filter:'blur(0)'},{transform:'translateX(45px)',opacity:0,filter:'blur(3px)'}],{duration:180,easing:'ease-in',fill:'forwards'});
    await outgoing.finished.catch(()=>{});
    previous.hidden=true;outgoing.cancel();active=(active+1)%slides.length;slides[active].hidden=false;
    const incoming=slides[active].animate([{transform:'translateX(-45px)',opacity:0,filter:'blur(3px)'},{transform:'translateX(0)',opacity:1,filter:'blur(0)'}],{duration:220,easing:'ease-out'});
    await incoming.finished.catch(()=>{});transitioning=false;
  }
  function sync(){clearInterval(timer);if(carousel&&!reduced.matches&&!document.hidden)timer=setInterval(rotate,5000);}
  reduced.addEventListener('change',sync);document.addEventListener('visibilitychange',sync);
  addEventListener('pagehide',()=>clearInterval(timer));addEventListener('pageshow',sync);sync();
  document.querySelectorAll('[data-shop-now]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();{const offer=document.querySelector('#purchase-form');offer?.scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'start'});const field=offer?.querySelector('input:checked');if(field)field.focus({preventScroll:true});}}));
  const photos=[...document.querySelectorAll('[data-photo]')];
  if(photos.length){const dialog=document.createElement('dialog');dialog.className='photo-dialog';dialog.setAttribute('aria-label','Zdjęcie klienta w pełnym rozmiarze');const close=document.createElement('button');close.type='button';close.textContent='✕';close.setAttribute('aria-label','Zamknij zdjęcie');const img=document.createElement('img');dialog.append(close,img);document.body.append(dialog);close.addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});photos.forEach(button=>button.addEventListener('click',()=>{img.src=button.dataset.photo;img.alt=button.querySelector('img').alt;dialog.showModal()}));}
})();
(() => {
  const hero=document.querySelector('.product-top'),gallery=hero?.querySelector('.gallery'),purchase=hero?.querySelector('.purchase-card'),proof=gallery?.querySelector('.social-proof');
  if(!hero||!proof)return;
  const desktop=matchMedia('(min-width:900px)');
  let frame;
  function layout(){
    if(desktop.matches){purchase.prepend(proof);hero.style.removeProperty('--mobile-image-size');return;}
    gallery.append(proof);
    const width=gallery.clientWidth;
    hero.style.setProperty('--mobile-image-size',width+'px');
    const description=purchase.querySelector('h1');
    const available=(window.visualViewport?.height||innerHeight)-10;
    let size=width;
    for(let pass=0;pass<3;pass++){
      const excess=description.getBoundingClientRect().bottom+scrollY-available;
      if(excess<=0||size<=120)break;
      size=Math.max(120,size-excess);
      hero.style.setProperty('--mobile-image-size',Math.floor(size)+'px');
    }
  }
  const schedule=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(layout);};
  desktop.addEventListener('change',schedule);addEventListener('resize',schedule);window.visualViewport?.addEventListener('resize',schedule);
  const observer=new ResizeObserver(schedule);observer.observe(purchase.querySelector('h1'));
  document.fonts.ready.then(schedule);layout();
})();
(() => {
  document.querySelectorAll('[data-count]').forEach(badge=>{
    const update=()=>badge.hidden=Number(badge.textContent.trim())===0;
    new MutationObserver(update).observe(badge,{childList:true,characterData:true,subtree:true});update();
  });
})();
(() => {
  const drawer=document.querySelector('.cart-drawer'),items=drawer?.querySelector('[data-cart-items]'),hint=drawer?.querySelector('[data-cart-scroll-hint]');
  if(!items||!hint)return;
  const update=()=>{const more=drawer.open&&items.scrollHeight-items.clientHeight-items.scrollTop>2;hint.hidden=!more;drawer.classList.toggle('has-more',more);};
  items.addEventListener('scroll',update,{passive:true});
  new ResizeObserver(update).observe(items);
  new MutationObserver(update).observe(items,{childList:true,subtree:true});
  new MutationObserver(update).observe(drawer,{attributes:true,attributeFilter:['open']});
  update();
})();

(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('#faq details').forEach(details => {
    const summary = details.querySelector('summary');
    let animation, expanded = details.open;
    summary.addEventListener('click', event => {
      if (reduced.matches) return;
      event.preventDefault();
      const start = details.getBoundingClientRect().height;
      if (!animation) expanded = details.open;
      expanded = !expanded;
      animation?.cancel();
      details.style.height = '';
      details.open = expanded;
      const end = details.getBoundingClientRect().height;
      details.open = true;
      details.style.overflow = 'hidden';
      animation = details.animate([{height: start + 'px'}, {height: end + 'px'}], {duration: 230, easing: 'ease-in-out'});
      animation.onfinish = () => {
        details.open = expanded;
        details.style.overflow = '';
        animation = null;
      };
    });
    reduced.addEventListener('change', () => {
      if (!animation) return;
      animation.cancel();
      animation = null;
      details.open = expanded;
      details.style.overflow = '';
    });
  });
})();
